import PropTypes from 'prop-types';

const propType = {
  address_1: PropTypes.string.isRequired,
  address_2: PropTypes.string,
  city: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
};

const defaultProp = {
  address_1: '',
  address_2: '',
  city: '',
  zipCode: '',
  state: '',
  countryCode: '',
};

const requiredFields = {
  address_1: true,
  address_2: false,
  city: true,
  zipCode: true,
  state: true,
  countryCode: true,
};

export default { propType, defaultProp, requiredFields };
